import React from "react";

export default function Features()
{
  return (
    <section id="features" className="home-features">
      <div className="container ">
        <div className="sc-content wow fadeInUp">
          <div className="left">
            <div className="img_ bg_contain">
              <div className="img__ bg_contain"></div>
            </div>
          </div>
          <div className="right">
            <div className="block_50  "></div>
            <h3>
              Why Choose Rocket Raccoon?</h3>
            <p>With clics' budgeting system, you can rest assured your resources are spent wisely.</p>
            <div className="block_50  "></div>
            <div className="list_">
              <ul>
                <li>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Transparency & Immutability</span>
                  </div>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Lower gas Fees and Security</span>
                  </div>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Strong community</span>
                  </div>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Strong community</span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="block_50  "></div>
          </div>

        </div>
      </div>
      {/* <canvas id="c2" /> */}
    </section>
  );
}
